import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { BannerService } from 'services';
import { PaperClip, Button, Input } from 'components';
import { UploadIcon, ArrowRightBlack, ArrowLeftBlack, TrashIcon } from 'assets/icons';
import { Constants, Globals, checkPermission } from 'utils';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Banners extends React.Component<Props> {

	state = {
		banners: [],
		banners_deleted: [],
		principal_index: 0,
		secondary_index: 0,
		advertising_index: 0
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Banners',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await BannerService.admin.get({
			withoutLoading
		});
		this.setState({
			banners: res.banners,
			banners_deleted: [],
			principal_index: 0,
			secondary_index: 0,
			advertising_index: 0
		});
	}	

	save = async () => {
		const index = this.state.banners.findIndex((i: any) => i.url != undefined && i.url != null && !Globals.isURL(i.url));
		const banner: any = this.state.banners[index];
		if (index != -1) {
			Globals.showError('La URL ' + '"' + banner?.url + '" no es válida');
			return;
		}

		await BannerService.admin.save({
			hasFile: true,
			principal: this.state.banners.filter((i: any) => i.type == Constants.BANNERS.PRINCIPAL && i.value !== null).map((i: any) => i?.value),
			secondary: this.state.banners.filter((i: any) => i.type == Constants.BANNERS.SECONDARY && i.value !== null).map((i: any) => i?.value),
			advertising: this.state.banners.filter((i: any) => i.type == Constants.BANNERS.ADVERTISING && i.value !== null).map((i: any) => i?.value),
			principal_url: JSON.stringify(this.state.banners.filter((i: any) => i.type == Constants.BANNERS.PRINCIPAL).map((i: any) => {
				return {
					url: i.url,
					id: i.id
				}				
			})),
			secondary_url: JSON.stringify(this.state.banners.filter((i: any) => i.type == Constants.BANNERS.SECONDARY).map((i: any) => {
				return {
					url: i.url,
					id: i.id
				}
			})),
			advertising_url: JSON.stringify(this.state.banners.filter((i: any) => i.type == Constants.BANNERS.ADVERTISING).map((i: any) => {
				return {
					url: i.url,
					id: i.id
				}
			})),
			banners_deleted: JSON.stringify(this.state.banners_deleted)
		});
		Globals.showSuccess("Se han guardado los banners correctamente");
		this.load(true);
	}

	delete = (item: any) => {
		if (item.id) {
			let banners_deleted: any = [...this.state.banners_deleted];
			banners_deleted.push(item.id);
			let banners: any = [...this.state.banners];
			const index = this.state.banners.findIndex((i: any) => i.id == item.id);
			banners.splice(index,1);
			this.setState({
				banners_deleted,
				banners
			});
		}
		else {
			let banners: any = [...this.state.banners];
			const index = this.state.banners.findIndex((i: any) => i.unique_id == item.unique_id);
			banners.splice(index,1);
			this.setState({
				banners
			});
		}
	}
	
	render() {
		const principal = this.state.banners.filter((i: any) => i.type == Constants.BANNERS.PRINCIPAL);
		const secondary = this.state.banners.filter((i: any) => i.type == Constants.BANNERS.SECONDARY);
		const advertising = this.state.banners.filter((i: any) => i.type == Constants.BANNERS.ADVERTISING);

		return (
			<div id="admin-shop-banners">
				<div className="row">
					<div className="col-md-8">
						<BackComponent />
					</div>
					<div className="col-md-4">
						{
							checkPermission(Constants.MODULES.BANNERS,'write') && (
								<div className="container-btn-submit">
									<Button type="submit" onClick={ () => this.save() }>
										Guardar
									</Button>
								</div>
							)
						}
					</div>
				</div>
				
				<div className="row">
					<div className="col-md-4">
						<h4>Banners principales</h4>
					</div>
					<div className="col-md-8">
						<div className="container-item">
							<div className="item">
								<button className="btn-arrow" disabled={ this.state.principal_index == 0 } onClick={ () => {
									let principal_index = this.state.principal_index;
									if (principal_index > 0) {
										principal_index--;
										this.setState({
											principal_index
										});
									}
								} }>
									{
										this.state.principal_index > 0 && (
											<img src={ ArrowLeftBlack } />
										)
									}
								</button>
								
								<PaperClip
									value={ null }
									successText={ `` }
									pendingText={ `` }
									width={ 1690 }
									height={ 230 }
									disabled={ !checkPermission(Constants.MODULES.BANNERS,'write') }
									onChange={ async (e: any) => {
										let banners: any = [...this.state.banners];
										if (principal[this.state.principal_index] != null) {
											// @ts-ignore
											const index = this.state.banners.findIndex((i: any) => principal[this.state.principal_index]?.id != null ? i.id == principal[this.state.principal_index]?.id : i.unique_id == principal[this.state.principal_index]?.unique_id);
											banners[index] = {
												// @ts-ignore
												...principal[this.state.principal_index],
												...e.target,
												id: null,
												unique_id: moment().format('YYYYMMDDHHmmss')
											};
											// @ts-ignore
											if (principal[this.state.principal_index]?.id) {
												let banners_deleted: any = [...this.state.banners_deleted];
												// @ts-ignore
												banners_deleted.push(principal[this.state.principal_index]?.id);
												await this.setState({
													banners_deleted
												});
											}
										}
										else {
											banners.push({
												...e.target,
												type: Constants.BANNERS.PRINCIPAL,
												unique_id: moment().format('YYYYMMDDHHmmss')
											});
											await this.setState({
												principal_index: principal.length
											});
										}
										this.setState({
											banners
										});
									} }>
									{
										principal[this.state.principal_index] == null && (
											<div className="container-image">
												<img src={ UploadIcon } />
												<p>Subir Imagen</p>
											</div>
										)
									}
									{
										principal[this.state.principal_index] != null && (
											// @ts-ignore
											<img className="image-selected" src={ principal[this.state.principal_index]?.id != null ? (Constants.BASE_STORAGE + principal[this.state.principal_index]?.file) : principal[this.state.principal_index].dataURL } />
										)
									}
								</PaperClip>

								<button className="btn-arrow" disabled={ this.state.principal_index == 4 } onClick={ () => {
									let principal_index = this.state.principal_index;
									if (principal_index < 4) {
										principal_index++;
										this.setState({
											principal_index
										});
									}
								} }>
									{
										this.state.principal_index < 4 && (
											<img src={ ArrowRightBlack } />
										)
									}
								</button>
							</div>

							{
								checkPermission(Constants.MODULES.BANNERS,'write') && principal[this.state.principal_index] != null && (
									<Input
										color="white"
										// @ts-ignore
										value={ principal[this.state.principal_index]?.url || '' }
										name="name" 
										placeholder="URL (Opcional)"
										onChange={ (e: any) => {
											let banners: any = [...this.state.banners];
											if (principal[this.state.principal_index] != null) {
												// @ts-ignore
												const index = this.state.banners.findIndex((i: any) => principal[this.state.principal_index]?.id != null ? i.id == principal[this.state.principal_index]?.id : i.unique_id == principal[this.state.principal_index]?.unique_id);
												banners[index] = {
													// @ts-ignore
													...principal[this.state.principal_index],
													url: e.target.value
												};
											}
											this.setState({
												banners
											});
										} } />
								)
							}

							<div className="flex-badges">
								<div className="container-badges">
									<div className={ `item-badge ${ this.state.principal_index == 0 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 0
										});
									} }></div>
									<div className={ `item-badge ${ this.state.principal_index == 1 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 1
										});
									} }></div>
									<div className={ `item-badge ${ this.state.principal_index == 2 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 2
										});
									} }></div>
									<div className={ `item-badge ${ this.state.principal_index == 3 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 3
										});
									} }></div>
									<div className={ `item-badge ${ this.state.principal_index == 4 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											principal_index: 4
										});
									} }></div>
								</div>
								<div className="text-right">
									{
										principal[this.state.principal_index] != null && (
											<React.Fragment>
												{
													checkPermission(Constants.MODULES.BANNERS,'delete') && (
														<button className="btn-delete" onClick={ () => this.delete(principal[this.state.principal_index]) }>
															<img src={ TrashIcon } />
															<p>Eliminar</p>
														</button>
													)
												}
												{
													checkPermission(Constants.MODULES.BANNERS,'write') && (
														<PaperClip
															value={ null }
															successText={ `` }
															pendingText={ `` }
															width={ 1690 }
															height={ 230 }
															onChange={ async (e: any) => {
																let banners: any = [...this.state.banners];
																if (principal[this.state.principal_index] != null) {
																	// @ts-ignore
																	const index = this.state.banners.findIndex((i: any) => principal[this.state.principal_index]?.id != null ? i.id == principal[this.state.principal_index]?.id : i.unique_id == principal[this.state.principal_index]?.unique_id);
																	banners[index] = {
																		// @ts-ignore
																		...principal[this.state.principal_index],
																		...e.target,
																		id: null,
																		unique_id: moment().format('YYYYMMDDHHmmss')
																	};
																	// @ts-ignore
																	if (principal[this.state.principal_index]?.id) {
																		let banners_deleted: any = [...this.state.banners_deleted];
																		// @ts-ignore
																		banners_deleted.push(principal[this.state.principal_index]?.id);
																		await this.setState({
																			banners_deleted
																		});
																	}
																}
																else {
																	banners.push({
																		...e.target,
																		type: Constants.BANNERS.PRINCIPAL,
																		unique_id: moment().format('YYYYMMDDHHmmss')
																	});
																	await this.setState({
																		principal_index: principal.length
																	});
																}
																this.setState({
																	banners
																});
															} }>
															<button className="btn-change">
																<img src={ UploadIcon } />
																<p>Cambiar</p>
															</button>
														</PaperClip>
													)
												}
											</React.Fragment>
										)
									}
								</div>
							</div>
						</div>
						<p className="message">Puede subir hasta 5 banners principales. Tamaño requerido: 1690px por 230px.</p>
					</div>
					<div className="col-md-4">
						<h4>Banners secundarios</h4>
					</div>
					<div className="col-md-8">
						<div className="container-item">
							<div className="item">
								<button className="btn-arrow" disabled={ this.state.secondary_index == 0 } onClick={ () => {
									let secondary_index = this.state.secondary_index;
									if (secondary_index > 0) {
										secondary_index--;
										this.setState({
											secondary_index
										});
									}
								} }>
									{
										this.state.secondary_index > 0 && (
											<img src={ ArrowLeftBlack } />
										)
									}
								</button>
								
								<PaperClip
									value={ null }
									successText={ `` }
									pendingText={ `` }
									width={ 1332 }
									height={ 400 }
									disabled={ !checkPermission(Constants.MODULES.BANNERS,'write') }
									onChange={ async (e: any) => {
										let banners: any = [...this.state.banners];
										if (secondary[this.state.secondary_index] != null) {
											// @ts-ignore
											const index = this.state.banners.findIndex((i: any) => secondary[this.state.secondary_index]?.id != null ? i.id == secondary[this.state.secondary_index]?.id : i.unique_id == secondary[this.state.secondary_index]?.unique_id);
											banners[index] = {
												// @ts-ignore
												...secondary[this.state.secondary_index],
												...e.target,
												id: null,
												unique_id: moment().format('YYYYMMDDHHmmss')
											};
											// @ts-ignore
											if (secondary[this.state.secondary_index]?.id) {
												let banners_deleted: any = [...this.state.banners_deleted];
												// @ts-ignore
												banners_deleted.push(secondary[this.state.secondary_index]?.id);
												await this.setState({
													banners_deleted
												});
											}
										}
										else {
											banners.push({
												...e.target,
												type: Constants.BANNERS.SECONDARY,
												unique_id: moment().format('YYYYMMDDHHmmss')
											});
											await this.setState({
												secondary_index: secondary.length
											});
										}
										this.setState({
											banners
										});
									} }>
									{
										secondary[this.state.secondary_index] == null && (
											<div className="container-image">
												<img src={ UploadIcon } />
												<p>Subir Imagen</p>
											</div>
										)
									}
									{
										secondary[this.state.secondary_index] != null && (
											// @ts-ignore
											<img className="image-selected" src={ secondary[this.state.secondary_index]?.id != null ? (Constants.BASE_STORAGE + secondary[this.state.secondary_index]?.file) : secondary[this.state.secondary_index].dataURL } />
										)
									}
								</PaperClip>

								<button className="btn-arrow" disabled={ this.state.secondary_index == 4 } onClick={ () => {
									let secondary_index = this.state.secondary_index;
									if (secondary_index < 4) {
										secondary_index++;
										this.setState({
											secondary_index
										});
									}
								} }>
									{
										this.state.secondary_index < 4 && (
											<img src={ ArrowRightBlack } />
										)
									}
								</button>
							</div>

							{
								checkPermission(Constants.MODULES.BANNERS,'write') && secondary[this.state.secondary_index] != null && (
									<Input
										color="white"
										// @ts-ignore
										value={ secondary[this.state.secondary_index]?.url || '' }
										name="name" 
										placeholder="URL (Opcional)"
										onChange={ (e: any) => {
											let banners: any = [...this.state.banners];
											if (secondary[this.state.secondary_index] != null) {
												// @ts-ignore
												const index = this.state.banners.findIndex((i: any) => secondary[this.state.secondary_index]?.id != null ? i.id == secondary[this.state.secondary_index]?.id : i.unique_id == secondary[this.state.secondary_index]?.unique_id);
												banners[index] = {
													// @ts-ignore
													...secondary[this.state.secondary_index],
													url: e.target.value
												};
											}
											this.setState({
												banners
											});
										} } />
								)
							}

							<div className="flex-badges">
								<div className="container-badges">
									<div className={ `item-badge ${ this.state.secondary_index == 0 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											secondary_index: 0
										});
									} }></div>
									<div className={ `item-badge ${ this.state.secondary_index == 1 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											secondary_index: 1
										});
									} }></div>
									<div className={ `item-badge ${ this.state.secondary_index == 2 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											secondary_index: 2
										});
									} }></div>
									<div className={ `item-badge ${ this.state.secondary_index == 3 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											secondary_index: 3
										});
									} }></div>
									<div className={ `item-badge ${ this.state.secondary_index == 4 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											secondary_index: 4
										});
									} }></div>
								</div>
								<div className="text-right">
									{
										secondary[this.state.secondary_index] != null && (
											<React.Fragment>
												{
													checkPermission(Constants.MODULES.BANNERS,'delete') && (
														<button className="btn-delete" onClick={ () => this.delete(secondary[this.state.secondary_index]) }>
															<img src={ TrashIcon } />
															<p>Eliminar</p>
														</button>
													)
												}
												{
													checkPermission(Constants.MODULES.BANNERS,'write') && (
														<PaperClip
															width={ 1332 }
															height={ 400 }
															value={ null }
															successText={ `` }
															pendingText={ `` }
															onChange={ async(e: any) => {
																let banners: any = [...this.state.banners];
																if (secondary[this.state.secondary_index] != null) {
																	// @ts-ignore
																	const index = this.state.banners.findIndex((i: any) => secondary[this.state.secondary_index]?.id != null ? i.id == secondary[this.state.secondary_index]?.id : i.unique_id == secondary[this.state.secondary_index]?.unique_id);
																	banners[index] = {
																		// @ts-ignore
																		...secondary[this.state.secondary_index],
																		...e.target,
																		id: null,
																		unique_id: moment().format('YYYYMMDDHHmmss')
																	};
																	// @ts-ignore
																	if (secondary[this.state.secondary_index]?.id) {
																		let banners_deleted: any = [...this.state.banners_deleted];
																		// @ts-ignore
																		banners_deleted.push(secondary[this.state.secondary_index]?.id);
																		await this.setState({
																			banners_deleted
																		});
																	}
																}
																else {
																	banners.push({
																		...e.target,
																		type: Constants.BANNERS.SECONDARY,
																		unique_id: moment().format('YYYYMMDDHHmmss')
																	});
																	await this.setState({
																		secondary_index: secondary.length
																	});
																}
																this.setState({
																	banners
																});
															} }>
															<button className="btn-change">
																<img src={ UploadIcon } />
																<p>Cambiar</p>
															</button>
														</PaperClip>
													)
												}
											</React.Fragment>
										)
									}
								</div>
							</div>
						</div>
						<p className="message">Puede subir hasta 5 banners secundarios. Tamaño requerido: 1332px por 400px.</p>
					</div>
					<div className="col-md-4">
						<h4>Anuncios</h4>
					</div>
					<div className="col-md-8">
						<div className="container-item">
							<div className="item">
								<button className="btn-arrow" disabled={ this.state.advertising_index == 0 } onClick={ () => {
									let advertising_index = this.state.advertising_index;
									if (advertising_index > 0) {
										advertising_index--;
										this.setState({
											advertising_index
										});
									}
								} }>
									{
										this.state.advertising_index > 0 && (
											<img src={ ArrowLeftBlack } />
										)
									}
								</button>

								<PaperClip
									value={ null }
									successText={ `` }
									pendingText={ `` }
									width={ 307 }
									height={ 500 }
									disabled={ !checkPermission(Constants.MODULES.BANNERS,'write') }
									onChange={ async (e: any) => {
										let banners: any = [...this.state.banners];
										if (advertising[this.state.advertising_index] != null) {
											// @ts-ignore
											const index = this.state.banners.findIndex((i: any) => advertising[this.state.advertising_index]?.id != null ? i.id == advertising[this.state.advertising_index]?.id : i.unique_id == advertising[this.state.advertising_index]?.unique_id);
											banners[index] = {
												// @ts-ignore
												...advertising[this.state.advertising_index],
												...e.target,
												id: null,
												unique_id: moment().format('YYYYMMDDHHmmss')
											};
											// @ts-ignore
											if (advertising[this.state.advertising_index]?.id) {
												let banners_deleted: any = [...this.state.banners_deleted];
												// @ts-ignore
												banners_deleted.push(advertising[this.state.advertising_index]?.id);
												await this.setState({
													banners_deleted
												});
											}
										}
										else {
											banners.push({
												...e.target,
												type: Constants.BANNERS.ADVERTISING,
												unique_id: moment().format('YYYYMMDDHHmmss')
											});
											await this.setState({
												advertising_index: advertising.length
											});
										}
										this.setState({
											banners
										});
									} }>
									{
										advertising[this.state.advertising_index] == null && (
											<div className="container-image">
												<img src={ UploadIcon } />
												<p>Subir Imagen</p>
											</div>
										)
									}
									{
										advertising[this.state.advertising_index] != null && (
											// @ts-ignore
											<img className="image-selected" src={ advertising[this.state.advertising_index]?.id != null ? (Constants.BASE_STORAGE + advertising[this.state.advertising_index]?.file) : advertising[this.state.advertising_index].dataURL } />
										)
									}
								</PaperClip>

								<button className="btn-arrow" disabled={ this.state.advertising_index == 1 } onClick={ () => {
									let advertising_index = this.state.advertising_index;
									if (advertising_index < 1) {
										advertising_index++;
										this.setState({
											advertising_index
										});
									}
								} }>
									{
										this.state.advertising_index < 1 && (
											<img src={ ArrowRightBlack } />
										)
									}
								</button>
							</div>

							{
								checkPermission(Constants.MODULES.BANNERS,'write') && advertising[this.state.advertising_index] != null && (
									<Input
										color="white"
										// @ts-ignore
										value={ advertising[this.state.advertising_index]?.url || '' }
										name="name" 
										placeholder="URL (Opcional)"
										onChange={ (e: any) => {
											let banners: any = [...this.state.banners];
											if (advertising[this.state.advertising_index] != null) {
												// @ts-ignore
												const index = this.state.banners.findIndex((i: any) => advertising[this.state.advertising_index]?.id != null ? i.id == advertising[this.state.advertising_index]?.id : i.unique_id == advertising[this.state.advertising_index]?.unique_id);
												banners[index] = {
													// @ts-ignore
													...advertising[this.state.advertising_index],
													url: e.target.value
												};
											}
											this.setState({
												banners
											});
										} } />
								)
							}

							<div className="flex-badges">
								<div className="container-badges">
									<div className={ `item-badge ${ this.state.advertising_index == 0 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											advertising_index: 0
										});
									} }></div>
									<div className={ `item-badge ${ this.state.advertising_index == 1 ? 'active' : '' }` } onClick={ () => {
										this.setState({
											advertising_index: 1
										});
									} }></div>
								</div>
								<div className="text-right">
									{
										advertising[this.state.advertising_index] != null && (
											<React.Fragment>
												{
													checkPermission(Constants.MODULES.BANNERS,'delete') && (
														<button className="btn-delete" onClick={ () => this.delete(advertising[this.state.advertising_index]) }>
															<img src={ TrashIcon } />
															<p>Eliminar</p>
														</button>
													)
												}
												{
													checkPermission(Constants.MODULES.BANNERS,'write') && (
														<PaperClip
															value={ null }
															successText={ `` }
															pendingText={ `` }
															width={ 307 }
															height={ 500 }
															onChange={ async (e: any) => {
																let banners: any = [...this.state.banners];
																if (advertising[this.state.advertising_index] != null) {
																	// @ts-ignore
																	const index = this.state.banners.findIndex((i: any) => advertising[this.state.advertising_index]?.id != null ? i.id == advertising[this.state.advertising_index]?.id : i.unique_id == advertising[this.state.advertising_index]?.unique_id);
																	banners[index] = {
																		// @ts-ignore
																		...advertising[this.state.advertising_index],
																		...e.target,
																		id: null,
																		unique_id: moment().format('YYYYMMDDHHmmss')
																	};
																	// @ts-ignore
																	if (advertising[this.state.advertising_index]?.id) {
																		let banners_deleted: any = [...this.state.banners_deleted];
																		// @ts-ignore
																		banners_deleted.push(advertising[this.state.advertising_index]?.id);
																		await this.setState({
																			banners_deleted
																		});
																	}
																}
																else {
																	banners.push({
																		...e.target,
																		type: Constants.BANNERS.ADVERTISING,
																		unique_id: moment().format('YYYYMMDDHHmmss')
																	});
																	await this.setState({
																		advertising_index: advertising.length
																	});
																}
																this.setState({
																	banners
																});
															} }>
															<button className="btn-change">
																<img src={ UploadIcon } />
																<p>Cambiar</p>
															</button>
														</PaperClip>
													)
												}
											</React.Fragment>
										)
									}
								</div>
							</div>
						</div>
						<p className="message">Puede subir hasta 2 anuncios. Tamaño requerido: 307px por 500px.</p>
					</div>
				</div>

				<div className="row row-buttons">
					<div className="col-md-12">
						{
							checkPermission(Constants.MODULES.BANNERS,'write') && (
								<div className="text-center">
									<Button type="submit" className="btn-submit" onClick={ () => this.save() }>
										Guardar
									</Button>
								</div>
							)
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(Banners);